module.exports = __webpack_public_path__ + "img/sec2-1.73a838de.png";